import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/transfers`;

export const transferService = {
  // Get all transfers
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.from_e_ledger_id) params.append('from_e_ledger_id', filters.from_e_ledger_id);
    if (filters.to_e_ledger_id) params.append('to_e_ledger_id', filters.to_e_ledger_id);
    if (filters.verification_status) params.append('verification_status', filters.verification_status);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  // Get transfer by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  // Initiate transfer
  initiate: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  // Verify transfer
  verify: async (id, status) => {
    const response = await axios.put(`${API_BASE}/${id}/verify`, { verification_status: status });
    return response.data;
  },

  // Get audit trail
  getAuditTrail: async (ledgerId) => {
    const response = await axios.get(`${API_BASE}/audit-trail/${ledgerId}`);
    return response.data;
  }
};

export default transferService;
